import { createContext } from 'react';
import { noop } from 'lodash';

import { OverlayType } from '../../../constants';

interface IMobileFiltersCtx {
    currentOverlay: OverlayType;
    setOverlay: (nextOverlay: OverlayType) => void;
}

const MobileFiltersCtx = createContext<IMobileFiltersCtx>({
    currentOverlay: OverlayType.NONE,
    setOverlay: noop,
});

export default MobileFiltersCtx;
